import React from 'react'
import { Container } from 'reactstrap'

import ColorCard from '../../../ColorCard'

const ITEMS = [
  {
    color: 'blue',
    title: 'Operational Excellence',
    text:
      'The operational excellence pillar ensures that your systems deliver business value and continually improve with processes and procedures.',
  },
  {
    color: 'dark-blue',
    title: 'Security',
    text:
      'The security pillar ensures that your data and systems are protected through risk assessments and mitigation strategies.',
  },
  {
    color: 'green',
    title: 'Reliability',
    text:
      'The reliability pillar ensures that your systems keep adding value. Whether a disruption occurs or your demand for computing power increases, you’ll have what you need to stay online.',
  },
  {
    color: 'orange',
    title: 'Performance Efficiency',
    text:
      'The performance efficiency pillar ensures that computing resources are allocated to your systems so they meet minimum system requirements in the most efficient way possible. It also ensures that efficiency continues through fluctuations in demand and technological changes.',
  },
  {
    color: 'burnt-orange',
    title: 'Cost Optimization',
    text:
      'The cost optimization pillar ensures that your systems deliver value at the lowest possible price point.',
  },
]

const Pillars = () => {
  return (
    <section className="Pillars">
      <Container>
        <div className="d-lg-flex align-items-lg-stretch">
          <div className="w-lg-66 pr-lg-4">
            <h2 className="Pillars__title pb-2 pb-lg-3">
              Build on the <span className="text-dark-blue">Five Pillars</span>
            </h2>

            <p>
              The AWS Well-Architected Framework (WAF) is a comprehensive guide
              on how to best operate infrastructure on the AWS platform. The WAF
              provides high-level guidance on best practices to help customers
              properly leverage AWS capabilities.
            </p>

            <p>
              The WAF is based on five pillars: operational excellence,
              security, reliability, performance efficiency, and cost
              optimization.
            </p>
          </div>

          <div className="d-lg-flex align-items-end w-lg-33">
            <div>
              <a
                href="https://register.gotowebinar.com/#recording/6407943177959301384"
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-outline-primary w-lg-100 mb-3 mb-md-0 mr-md-3 ml-lg-3 mb-lg-3"
              >
                Watch Webinar Overview
              </a>

              <a
                href="/contact"
                className="btn btn-outline-primary mb-lg-3 ml-lg-3 w-lg-100"
              >
                Schedule Your Review
              </a>
            </div>
          </div>
        </div>

        <div className="pt-5 d-md-flex flex-md-wrap">
          {ITEMS.map((item, idx) => (
            <div
              key={idx}
              className="w-md-50 pl-md-2 pr-md-2 w-xl-33 pl-lg-3 pr-lg-3 Pillars__item"
            >
              <ColorCard {...item} />
            </div>
          ))}
        </div>
      </Container>
    </section>
  )
}

export default Pillars
